import SwagCmsExtensionsFormValidationService from './form-validation.service';

const initContainer = Shopware.Application.getContainer('init');

Shopware.Application.addServiceProvider('SwagCmsExtensionsFormValidationService', (container) => {
    return new SwagCmsExtensionsFormValidationService(initContainer.httpClient, container.loginService);
});
